import { render, staticRenderFns } from "./AKAccessDeniedMessage.vue?vue&type=template&id=146dc518&scoped=true&"
import script from "./AKAccessDeniedMessage.vue?vue&type=script&lang=js&"
export * from "./AKAccessDeniedMessage.vue?vue&type=script&lang=js&"
import style0 from "./AKAccessDeniedMessage.vue?vue&type=style&index=0&id=146dc518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146dc518",
  null
  
)

export default component.exports